class StorageClass {
    _getStorage() {
        return window.localStorage;
    }

    getItem(item: string) {
        return this._getStorage().getItem(item);
    }

    setItem(item: string, value: string) {
        this._getStorage().setItem(item, value);
    }

    removeItem(item: string) {
        this._getStorage().removeItem(item);
    }

    clear() {
        localStorage.clear();
        sessionStorage.clear();
    }
}

export const Storage = new StorageClass();
